import * as PropTypes from 'prop-types';
import { ReactNode } from 'react';

import Header from './Header';
import { NavigationLink } from './NavigationLink';

import { useMsal } from '@azure/msal-react';
import EnterpriseFooter from '@pds-react/enterpriseFooter';
import ErrorEventNavigation from './ErrorEventNavigation';
import './MainContainer.css';
import { MappingsNavigation } from './MappingsNavigation';
import TransactionsNavigation from './TransactionsNavigation';

interface MainContainerProps {
    children: ReactNode;
    section?: string;
    secondarySection?: string;
    headerSection?: boolean;
}

const MainContainer = ({ children, section, secondarySection, headerSection = true }: MainContainerProps) => {
    const { instance } = useMsal();
    instance.setActiveAccount(instance.getAllAccounts()[0]);

    const watermarkClass: string =
        window.location.hostname === 'accounting.salescompadmin.principal.com' ? '' : 'nonprod-class';

    return (
        <div className={watermarkClass}>
            {headerSection && (
                <>
                    <Header>
                        <NavigationLink title="Transactions" link="/transactions" />
                        <NavigationLink title="Mappings" link="/mappings" />
                        <NavigationLink title="Errors" link="/error-events" />
                    </Header>

                    <>{section === 'errorEvents' && <ErrorEventNavigation secondarySection={secondarySection} />}</>
                    <>{section === 'transactions' && <TransactionsNavigation secondarySection={secondarySection} />}</>
                    <>{section === 'mappings' && <MappingsNavigation secondarySection={secondarySection} />}</>
                </>
            )}

            <div
                className="container-fluid"
                style={{
                    position: 'relative',
                    paddingBottom: '250px',
                    marginBottom: '20px'
                }}
            >
                <div className="row util-padding-top-20">
                    <div className="col-xl-10 col-xl-offset-1 app-main-container">{children}</div>
                </div>
            </div>

            <div
                style={{
                    position: 'absolute',
                    bottom: '0',
                    height: '250px',
                    width: '100%'
                }}
            >
                <EnterpriseFooter contactUsUrl="https://www.principal.com/contact-us" variant="light" />
            </div>
        </div>
    );
};

MainContainer.propTypes = {
    children: PropTypes.node.isRequired,
    section: PropTypes.string,
    headerSection: PropTypes.bool,
    secondarySection: PropTypes.string
};

export default MainContainer;
